<template>
    <div class="ppv3-integration-card">
        <div class="card-header">
            <div class="icon-container">
                <img :src="integration.icon" :alt="integration.name" class="integration-icon" />
            </div>
            <div class="actions">
                <label
                    v-if="!['google_calendar', 'alyas', 'mcp'].includes(integration.id) && integration.type !== 'outil'"
                    class="switch"
                >
                    <input
                        type="checkbox"
                        :checked="integration.active"
                        :disabled="['karafun', 'gemini'].includes(integration.id)"
                        @change="$emit('toggle', integration)"
                    />
                    <span class="slider round"></span>
                </label>

                <button class="settings-btn" @click="$emit('settings', integration)">
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <circle cx="12" cy="12" r="3"></circle>
                        <path
                            d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                        ></path>
                    </svg>
                </button>
                <!-- <select
                    v-if="integration.type === 'outil'"
                    class="form-select settings-btn order-select"
                    :value="integration.position"
                    @change="$emit('update-position', integration, $event.target.value)"
                    title="Changer l'ordre d'affichage"
                >
                    <option v-for="i in totalOutils" :key="i" :value="i">{{ i }}</option>
                </select> -->
                <a
                    v-if="
                        (integration.type === 'outil' || integration.id === 'mailjet') &&
                        integration.settings_url &&
                        integration.settings_url !== '#'
                    "
                    :href="integration.settings_url"
                    target="_blank"
                    class="settings-btn"
                    :title="$t('website_settings.outils.visit_website')"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-external-link"
                    >
                        <path d="M15 3h6v6" />
                        <path d="M10 14 21 3" />
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    </svg>
                </a>
            </div>
        </div>
        <div class="card-body">
            <h3 class="integration-name">{{ integration.type === 'outil' ? integration.name : $t(integration.name) }}</h3>
            <p class="integration-description">
                {{
                    integration.type === 'outil'
                        ? $i18n.locale === 'en'
                            ? integration.description_english
                            : integration.description
                        : $t(integration.description)
                }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IntegrationCard',
    props: {
        integration: {
            type: Object,
            required: true,
        },
        totalOutils: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style scoped>
.ppv3-integration-card {
    border: 1px solid #f1f5f9;
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);
    border-radius: 20px;
    padding: 28px 32px;
    /* Slightly reduced vertical padding */
    width: 100%;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.ppv3-integration-card:hover {
    transform: translateY(-5px);
    box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.06);
}

.card-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
}

.icon-container {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
}

.integration-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.settings-btn {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 10px;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.settings-btn:hover {
    background: #f8fafc;
    color: #1e293b;
    border-color: #cbd5e1;
}

.order-select {
    padding-right: 32px;
    padding-left: 10px;
    width: auto;
    font-size: clamp(12px, 0.729545vw, 16px);
    font-weight: 500;
}

.integration-name {
    font-weight: 700;
    font-size: 20px;
    color: #1e293b;
    margin: 0 0 12px 0;
}

.integration-description {
    font-size: 15px;
    line-height: 1.6;
    color: #64748b;
    margin: 0;
}

/* Switch styles */
.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 28px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e2e8f0;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: '';
    height: 22px;
    width: 22px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

input:checked + .slider {
    background-color: #6366f1;
}

input:focus + .slider {
    box-shadow: 0 0 1px #6366f1;
}

input:checked + .slider:before {
    -webkit-transform: translateX(22px);
    -ms-transform: translateX(22px);
    transform: translateX(22px);
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

input:disabled + .slider {
    cursor: not-allowed;
    opacity: 0.6;
}
</style>
